import { CartType } from '../constants/types/cart';
import { removeTrailingZeros } from '../util/price-formatting';
import CartDataInterface from '~/constants/interfaces/cart-data-interface';

export default class CartData implements CartDataInterface {
  cartData: CartType;

  constructor(props: CartType) {
    this.cartData = props;
  }

  get isGiftCardCheckout() {
    return this.cartData?.selection?.items[0]?.brandName === 'Gift certificate';
  }

  get hasDiscount() {
    return this.cartData?.selection?.discounts?.anyDiscount ?? false;
  }

  get discount() {
    return this.cartData?.selection?.totals?.totalDiscountPrice ?? 0;
  }

  get shippingCost() {
    return removeTrailingZeros(
      this.cartData?.selection?.totals?.shippingPrice ?? 0
    );
  }

  get shippingCostAsNumber() {
    return this.cartData?.selection?.totals?.shippingPriceAsNumber ?? 0;
  }

  get shippingMethodName() {
    return this.cartData?.selection?.shippingMethodName ?? 0;
  }

  get totalCost() {
    return removeTrailingZeros(
      this.cartData?.selection?.totals?.grandTotalPrice ?? 0
    );
  }

  get totalItemsCost() {
    return removeTrailingZeros(
      this.cartData?.selection?.totals?.itemsTotalPrice ?? 0
    );
  }

  get totalVAT() {
    return removeTrailingZeros(
      this.cartData?.selection?.totals?.grandTotalPriceTax ?? 0
    );
  }

  get totalItemsCostAsNumber() {
    return this.cartData?.selection?.totals?.itemsTotalPriceAsNumber ?? 0;
  }

  get totalCostAsNumber() {
    return this.cartData?.selection?.totals?.itemsTotalPriceAsNumber ?? 0;
  }

  get items() {
    return this.cartData.selection ? this.cartData.selection.items || [] : [];
  }

  get shippingMethods() {
    return this.cartData.shippingMethods;
  }

  get paymentMethods() {
    return this.cartData.paymentMethods;
  }

  get selectedShippingMethod() {
    return this.cartData.selection.shippingMethod;
  }

  get vouchers() {
    return this.cartData?.selection?.discounts?.vouchers ?? [];
  }

  get user() {
    return this.cartData.loggedIn;
  }

  get shippingAddress() {
    return this.cartData?.selection?.shippingAddress;
  }

  get currency() {
    return this.cartData.selection ? this.cartData.selection.currency : '';
  }

  get totalItemQuantity() {
    const totalQuantity = this.cartData.selection
      ? this.cartData.selection.totals.totalQuantity
      : 0;
    return totalQuantity;
  }
}
